import React from "react";
import OverParkedTable from "../../components/OverParked/OverParkedTable";
import "../../pages/AutomatedDailyReportPage/AutomatedDailyReport.scss";
import MonthlyOnlyDailyHeader from "../../components/MonthlyOnlyDailyHeader/MonthlyOnlyDailyHeader";
import MonthlyOnlyTransactionTable from "../../components/MonthlyOnlyTransactionTable/MonthlyOnlyTransactionTable";
import Table from "react-bootstrap/Table";

function normalizeRows(rows) {
  if (Array.isArray(rows)) {
    return rows;
  }
  if (Array.isArray(rows?.recordset)) {
    return rows.recordset;
  }
  return [];
}

function formatDateTime(value) {
  if (!value) {
    return "--";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return date.toLocaleString("en-US", { timeZone: "America/New_York" });
}

function MonthlyOnlyDailyPage({
  currentMonthliesIn,
  spaces,
  hourlyTransactionTable,
  overParkedData,
  garageName,
  fobActivity
}) {
  const fobRows = normalizeRows(fobActivity);
  const garageInfo = JSON.parse(localStorage.getItem(`${garageName}Info`) || "{}");
  const isMonthlySync = garageInfo?.garageType === "Monthlies Only";

  return (
    <>
      <MonthlyOnlyDailyHeader
        currentMonthliesIn={currentMonthliesIn}
        spaces={spaces}
      />
      <MonthlyOnlyTransactionTable
        hourlyTransactionTable={hourlyTransactionTable}
      />
      {isMonthlySync ? (
        <Table striped bordered className="report table-sm table__data">
          <thead>
            <tr className="table-warning">
              <th>User Number</th>
              <th>Park In</th>
              <th>Park Out</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {fobRows.length === 0 ? (
              <tr>
                <td colSpan={4}>No fob activity found for this day.</td>
              </tr>
            ) : (
              fobRows.map((row, index) => (
                <tr key={`${row.UserNumber}-${row.ParkInTime}-${index}`}>
                  <td>{row.UserNumber}</td>
                  <td>{formatDateTime(row.ParkInTime)}</td>
                  <td>{formatDateTime(row.ParkOutTime)}</td>
                  <td>{String(row.Status || "").toLowerCase() === "in-system" ? "in-system" : "complete"}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      ) : (
        <OverParkedTable
          overParkedData={overParkedData}
          garageName={garageName}
        />
      )}
    </>
  );
}

export default MonthlyOnlyDailyPage;
